<script lang="ts">
  import Page from '$components/page/Page.svelte';
  import Button from '$components/button/Button.svelte';
  import Image from '$lib/assets/safe-migration-header.webp';
  import { migrateSafeWallet } from '$services/wallet/migrateSafeWallet';
  import { goto } from '$app/navigation';
  import { isCirclesUser, isV2Human } from '$services/circles/circles';
  import type { Address } from '$types/address';
  import { type AppError, ErrorType } from '$types/error';
  import { log } from '$utils/__log';
  import { stateError } from '$states/error.svelte';
  import { goToTransition } from '$utils/goToTransition';

  let walletAddress = window.localStorage.getItem('legacySafeAddress') as Address;

  let isLoading = $state(false);

  const logOut = () => {
    window.localStorage.clear();
    window.sessionStorage.clear();
    goToTransition('left', '/welcome');
  };

  const migrateSafe = async () => {
    isLoading = true;
    try {
      const tx = await migrateSafeWallet(walletAddress);
      if (!tx) throw new Error('Failed safe migration tx');
      window.localStorage.setItem('metriAddress', walletAddress);

      log(tx, 'hasMigrated?');
      const isV2 = await isV2Human(walletAddress);
      if (isV2) {
        void goToTransition('right', '/migrate-domain');
      } else {
        if (!(await isCirclesUser(walletAddress))) {
          void goToTransition('right', '/migrate-domain');
        } else {
          void goToTransition('right', '/migrate-domain');
        }
      }
    } catch (error: unknown) {
      stateError.set({
        type: ErrorType.MODAL,
        rawError: error as AppError,
        message: `Error migrating safe:${error}`,
        actions: [
          {
            action: (): Promise<void> => goto('/migrate-safe'),
            text: 'Reload',
          },
        ],
      });
    }
    isLoading = false;
  };
</script>

<Page>
  {#snippet middle()}
    <div class="h-[370px]">
      <img src={Image} alt="Metri" class="h-full w-full object-cover" />
    </div>
    <div class="p-gno-page">
      <h3 class="typography-l-semibold-semibold">Migrate to a newer Safe version</h3>
      <div class="text-brand">
        <p class="my-4">
          To enhance your experience and safety, we need to upgrade your Safe Account version to
          1.4.1
        </p>
        <p>Please sign with a Passkey you picked before.</p>
      </div>
    </div>
  {/snippet}
  {#snippet bottom()}
    <div class="grid gap-3 p-gno-page">
      <Button ariaLabel="Log Out" variant="plain" onclick={logOut}>Log Out</Button>
      <Button ariaLabel="Migrate" variant="primary" pending={isLoading} onclick={migrateSafe}>
        Migrate Now
      </Button>
    </div>
  {/snippet}
</Page>
